import type { FC, ReactElement } from 'react';

import { useConfigSlice } from '../../../store/slices/config/selectors';
import { redirectParentIframe } from '../../../utils/redirect';
import { ButtonVariant } from '../../controls/button/Button';

import type { BlockingModalActionButton } from './BlockingModalContent';
import { BlockingModalContent } from './BlockingModalContent';

export const SessionExpiredConnected: FC = (): ReactElement => {
  const isSisalEnabled = useConfigSlice.casinoConfig()?.isSisalEnabled;
  const homeUrl = useConfigSlice.casinoConfig()?.homeUrl;

  const action: BlockingModalActionButton[] = homeUrl
    ? [
        {
          tk: 'OK',
          type: ButtonVariant.ACCENT,
          click: () => redirectParentIframe(homeUrl),
        },
      ]
    : [];

  return (
    <BlockingModalContent
      titleTk="PP_7"
      messageTk={isSisalEnabled ? 'ERROR_SISAL_9018' : 'SESSION_EXPIRED'}
      actions={action}
    />
  );
};
